import { rgba } from 'polished';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '~/assets/logo-reversed.svg';
import { Icon, Logo } from '~/components';
import { useWorkspace } from '~/contexts';
import { colors } from '~/styles';

const Container = styled.div`
  flex-shrink: 0;
  width: 100%;
  height: 3.125rem;
  border-bottom: solid 1px ${colors.grey75};
  z-index: 3;
`;

const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: inherit;
  font-weight: inherit;
  cursor: pointer;

  &:hover {
    background-color: ${rgba(colors.white, 0.04)};
    color: inherit;
  }
`;

const ExpandedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 0.625rem 0 1.0625rem;
`;

const ExpandedHomeLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  display: block;
  width: 5.625rem;
`;

const LogoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;

  > svg {
    width: 100%;
    height: auto;
  }
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  padding: 0;
  border: none;
  border-radius: 0.25rem;
  background: transparent;
  color: ${colors.grey40};
  font-size: 0.875rem;
  cursor: pointer;

  &:hover {
    color: ${colors.white};
  }
`;

export default function SidebarLogo({ sidebarExpanded, setSidebarExpanded }) {
  const { workspace } = useWorkspace();
  const homePath = workspace ? `/app/${workspace.key}` : '/';

  if (sidebarExpanded) {
    return (
      <Container>
        <ExpandedContainer>
          <ExpandedHomeLink to={homePath}>
            <LogoImage src={logo} alt="Ruddr" />
          </ExpandedHomeLink>
          <ToggleButton id="sidebar-expander" data-expanded={true} onClick={() => setSidebarExpanded(false)}>
            <Icon icon="sidebar" />
          </ToggleButton>
        </ExpandedContainer>
      </Container>
    );
  }

  return (
    <Container>
      <ExpandButton id="sidebar-expander" data-expanded={false} onClick={() => setSidebarExpanded(true)}>
        <LogoIcon>
          <Logo />
        </LogoIcon>
      </ExpandButton>
    </Container>
  );
}
